<h1 mat-dialog-title>
  <span *ngIf="dialogData?.titleIcon?.name" [ngClass]="dialogData?.titleIcon?.type" class="dialog-title-icon">
    <mat-icon [ngClass]="dialogData?.titleIcon?.type" class="glyph">{{ dialogData?.titleIcon?.name }}</mat-icon>
  </span>
  <ng-container *ngIf="dialogData?.title">{{ dialogData?.title }}</ng-container>
  <ng-container
    *ngIf="dialogData?.titleTemplateRef"
    [ngTemplateOutlet]="dialogData?.titleTemplateRef"
    [ngTemplateOutletContext]="dialogData?.titleTemplateRefContext"
  ></ng-container>
</h1>

<div mat-dialog-content fxLayout="column" fxLayoutGap="12px">
  <div [ngClass]="{ 'content-bottom-padding': dialogData?.shouldSeparateFooter }" [innerHTML]="sanitizedText"></div>
  <ng-container *ngIf="dialogData?.bulletedList">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="12px"
      *ngFor="let bulletItem of dialogData.bulletedList"
    >
      <mat-icon *ngIf="bulletItem.icon" color="primary">{{ bulletItem.icon }}</mat-icon>
      <span>{{ bulletItem.text }}</span>
    </div>
  </ng-container>
  <ng-container
    [ngTemplateOutlet]="dialogData.templateRef"
    [ngTemplateOutletContext]="dialogData?.templateRefContext"
  ></ng-container>
  <ng-container *ngIf="dialogData.checkConfirmButtons">
    <div class="confirm-checkboxes" *ngFor="let confirmCheckbox of dialogData.checkConfirmButtons">
      <mat-checkbox
        *ngIf="confirmCheckbox.show"
        [checked]="confirmCheckbox.checked"
        (change)="checkConfirmButtonChange($event.checked, confirmCheckbox)"
      >
        <span class="ql-snow">
          <span class="ql-editor" [innerHTML]="sanitizeHtml(confirmCheckbox.label | translate)"></span>
        </span>
      </mat-checkbox>
    </div>
  </ng-container>
</div>
<div
  mat-dialog-actions
  [ngClass]="{
    'dialog-footer': true,
    separated: dialogData?.shouldSeparateFooter,
    stretched: dialogData?.shouldStretchFooterButtons
  }"
  fxLayout="row"
  [fxLayoutGap]="dialogData?.shouldStretchFooterButtons ? '16px' : '0px'"
  [fxLayoutAlign]="dialogData?.shouldStretchFooterButtons ? 'start' : 'end'"
>
  <button
    mat-button
    [fxFlex]="dialogData?.shouldStretchFooterButtons ? '100' : null"
    [color]="dialogData?.dismissButton.color"
    [disabled]="dialogData?.dismissButtonDisabled"
    [ngClass]="{
      'mat-flat-button': dialogData?.dismissButton.type === 'flat',
      'mat-raised-button': dialogData?.dismissButton.type === 'raised',
      'mat-stroked-button': dialogData?.dismissButton.type === 'stroked'
    }"
    (click)="onDismiss()"
  >
    <ng-container *ngIf="dialogData?.dismissButton.iconPlacement === 'prefix'">
      <mat-icon *ngIf="dialogData?.dismissButton.icon">{{ dialogData?.dismissButton.icon }}</mat-icon>
      {{ dialogData?.dismissButton.label }}
    </ng-container>
    <ng-container *ngIf="dialogData?.dismissButton.iconPlacement === 'suffix'">
      {{ dialogData?.dismissButton.label }}
      <mat-icon *ngIf="dialogData?.dismissButton.icon">{{ dialogData?.dismissButton.icon }}</mat-icon>
    </ng-container>
  </button>

  <button
    *ngIf="dialogData.confirmButton"
    mat-button
    [fxFlex]="dialogData?.shouldStretchFooterButtons ? '100' : null"
    [color]="dialogData?.confirmButton.color"
    [disabled]="dialogData?.confirmButtonDisabled"
    [ngClass]="{
      'mat-flat-button': dialogData?.confirmButton.type === 'flat',
      'mat-raised-button': dialogData?.confirmButton.type === 'raised',
      'mat-stroked-button': dialogData?.confirmButton.type === 'stroked'
    }"
    (click)="onConfirm()"
  >
    <ng-container *ngIf="dialogData?.confirmButton.iconPlacement === 'prefix'">
      <mat-icon *ngIf="dialogData?.confirmButton.icon">{{ dialogData?.confirmButton.icon }}</mat-icon>
      {{ dialogData?.confirmButton.label }}
    </ng-container>

    <ng-container *ngIf="dialogData?.confirmButton.iconPlacement === 'suffix'">
      {{ dialogData?.confirmButton.label }} <mat-icon>{{ dialogData?.confirmButton.icon }}</mat-icon>
    </ng-container>
  </button>

  <!-- extra -->
  <button
    *ngIf="dialogData?.extraButton"
    mat-button
    [fxFlex]="dialogData?.shouldStretchFooterButtons ? '100' : null"
    [color]="dialogData?.extraButton.color"
    [disabled]="dialogData?.extraButtonDisabled"
    [ngClass]="{
      'mat-flat-button': dialogData?.extraButton.type === 'flat',
      'mat-raised-button': dialogData?.extraButton.type === 'raised',
      'mat-stroked-button': dialogData?.extraButton.type === 'stroked'
    }"
    (click)="onExtraHandle()"
  >
    <ng-container *ngIf="dialogData?.extraButton.iconPlacement === 'prefix'">
      <mat-icon *ngIf="dialogData?.extraButton.icon">{{ dialogData?.extraButton.icon }}</mat-icon>
      {{ dialogData?.extraButton.label }}
    </ng-container>

    <ng-container *ngIf="dialogData?.extraButton.iconPlacement === 'suffix'">
      {{ dialogData?.extraButton.label }} <mat-icon>{{ dialogData?.extraButton.icon }}</mat-icon>
    </ng-container>
  </button>
</div>
